import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import { HouseOwnerEntity, LienEntity, SpecialConstraintEntity } from "../entities/ApplicationPropertyEntities";
class ApplicationPropertiesResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.applicationPropertyId = 0;
        this.applicationId = 0;
        this.propertyInformation = "";
        this.uniquePropertyId = "";
        this.type = "Unknown";
        this.cadastralNumber = "";
        this.municipalityNumber = 0;
        this.cadastralUnitNumber = 0;
        this.unitNumber = 0;
        this.leaseholdUnitNumber = 0;
        this.sectionNumber = 0;
        this.housingCooperativeName = "";
        this.housingCooperativeOrgNumber = "";
        this.housingCooperativeAccountant = "";
        this.shareNumber = 0;
        this.streetName = "";
        this.addressNumber = 0;
        this.addressLetter = "";
        this.postalCode = "";
        this.postalPlace = "";
        this.freeText = "";
        this.apartmentNumber = "";
        this.businessManager = "";
        this.housingCooperativeOrgName = "";
        this.refinance = false;
        this.valueEnteredByCustomer = 0;
        this.ownedByOthers = false;
        this.estimatedValue = 0;
        this.jointDebt = 0;
        this.eAppraisal = 0;
        this.pledgeValue = 0;
        this.utilizedValue = 0;
        this.utilizedSecurityValue = 0;
        this.eAppraisalReference = "";
        this.eAppraisalDate = undefined;
        this.mainCustomerResidence = false;
        this.useType = "";
        this.owners = [];
        this.newOwners = [];
        this.liens = [];
        this.newLiens = [];
        this.specialConstraints = [];
        this.deleteCadastral = false;
        this.addedManually = false;
    }
    pk() {
        return this.applicationPropertyId?.toString();
    }
}
ApplicationPropertiesResource.schema = {
    liens: [LienEntity],
    newLiens: [LienEntity],
    owners: [HouseOwnerEntity],
    newOwners: [HouseOwnerEntity],
    specialConstraints: [SpecialConstraintEntity]
};
ApplicationPropertiesResource.urlRoot = apiResourceUrl("property/{applicationId}");
export { ApplicationPropertiesResource };
//# sourceMappingURL=ApplicationPropertiesResource.js.map